// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-toolbar {
  --background: #161515;
  --color: #fff !important;
  --border-color: transparent;
}

.modal-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 12px 16px;
}

.modal-title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #fff;
}

.modal-subtitle {
  margin: 4px 0 0;
  font-size: 0.88rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.75);
}

.close-btn {
  --color: #fff;
  margin: 0;
}

.download-modal-content {
  --background: #f4f5f7;
}

.download-modal-shell {
  max-width: 920px;
  margin: 0 auto;
  padding: 20px 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.picker-card {
  background: #fff;
  border: 1px solid #e4e7ec;
  border-radius: 16px;
  padding: 18px;
  box-shadow: 0 6px 18px rgba(16, 24, 40, 0.06);
}

.picker-row {
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 16px;
  align-items: center;
}

.picker-label {
  font-size: 0.96rem;
  font-weight: 500;
  color: #344054;
}

.picker-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.software-select {
  flex: 1 1 280px;
  min-width: 240px;
  border: 1px solid #d0d5dd;
  border-radius: 12px;
  padding: 0 12px;
  background: #fff;
}

.type-select {
  flex: 0 0 180px;
  min-width: 160px;
}

.inline-message {
  margin-top: 12px;
  font-size: 0.88rem;
  color: #667085;
}

.inline-message.error {
  color: #b42318;
}

ion-button {
  --border-radius: 12px;
  min-height: 42px;
  font-weight: 500;
  text-transform: none;
}

@media (max-width: 768px) {
  .picker-row {
    grid-template-columns: 1fr;
    gap: 10px;
  }

  .picker-controls {
    flex-direction: column;
    align-items: stretch;
  }

  .software-select,
  .type-select,
  ion-button {
    width: 100%;
    min-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/layouts/main/pages/firmware-download/firmware-download.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,wBAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;AACF;;AAEA;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gCAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,6CAAA;AACF;;AAEA;EACE,aAAA;EACA,gCAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;AACF;;AAEA;EACE;IACE,0BAAA;IACA,SAAA;EACF;;EAEA;IACE,sBAAA;IACA,oBAAA;EAAF;;EAGA;;;IAGE,WAAA;IACA,eAAA;EADF;AACF","sourcesContent":[".download-toolbar {\r\n  --background: #161515;\r\n  --color: #fff !important;\r\n  --border-color: transparent;\r\n}\r\n\r\n.modal-toolbar {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  padding: 12px 16px;\r\n}\r\n\r\n.modal-title {\r\n  margin: 0;\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n  color: #fff;\r\n}\r\n\r\n.modal-subtitle {\r\n  margin: 4px 0 0;\r\n  font-size: 0.88rem;\r\n  font-weight: 400;\r\n  color: rgba(255, 255, 255, 0.75);\r\n}\r\n\r\n.close-btn {\r\n  --color: #fff;\r\n  margin: 0;\r\n}\r\n\r\n.download-modal-content {\r\n  --background: #f4f5f7;\r\n}\r\n\r\n.download-modal-shell {\r\n  max-width: 920px;\r\n  margin: 0 auto;\r\n  padding: 20px 16px 24px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.picker-card {\r\n  background: #fff;\r\n  border: 1px solid #e4e7ec;\r\n  border-radius: 16px;\r\n  padding: 18px;\r\n  box-shadow: 0 6px 18px rgba(16, 24, 40, 0.06);\r\n}\r\n\r\n.picker-row {\r\n  display: grid;\r\n  grid-template-columns: 220px 1fr;\r\n  gap: 16px;\r\n  align-items: center;\r\n}\r\n\r\n.picker-label {\r\n  font-size: 0.96rem;\r\n  font-weight: 500;\r\n  color: #344054;\r\n}\r\n\r\n.picker-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.software-select {\r\n  flex: 1 1 280px;\r\n  min-width: 240px;\r\n  border: 1px solid #d0d5dd;\r\n  border-radius: 12px;\r\n  padding: 0 12px;\r\n  background: #fff;\r\n}\r\n\r\n.type-select {\r\n  flex: 0 0 180px;\r\n  min-width: 160px;\r\n}\r\n\r\n.inline-message {\r\n  margin-top: 12px;\r\n  font-size: 0.88rem;\r\n  color: #667085;\r\n}\r\n\r\n.inline-message.error {\r\n  color: #b42318;\r\n}\r\n\r\nion-button {\r\n  --border-radius: 12px;\r\n  min-height: 42px;\r\n  font-weight: 500;\r\n  text-transform: none;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .picker-row {\r\n    grid-template-columns: 1fr;\r\n    gap: 10px;\r\n  }\r\n\r\n  .picker-controls {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .software-select,\r\n  .type-select,\r\n  ion-button {\r\n    width: 100%;\r\n    min-width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
